import { Box, IconButton, Menu, Tooltip, Typography } from '@mui/material';
import { SlidersHorizontal } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import MonacoExportCheckbox from '~/components/Checkboxes/MonacoExportCheckbox';
import DoseOpacityModifier from '~/components/Sliders/DoseOpacityModifier';
import GlobalContourThicknessModifier from '~/components/Sliders/GlobalContourThicknessModifier';

const GlobalSettings = () => {
    const intl = useIntl();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const menuOpen = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title={<FormattedMessage id="settings" />}>
                <IconButton
                    aria-label={intl.formatMessage({ id: 'settings' })}
                    aria-haspopup="true"
                    onClick={handleOpen}
                    size="small"
                    data-testid="open-global-settings"
                >
                    <SlidersHorizontal size={18} />
                </IconButton>
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{
                    paper: {
                        sx: (theme) => ({
                            ...theme.mixins.frostedSurface,
                            p: 2,
                            borderRadius: 2,
                            width: 'clamp(300px, 30vw, 400px)', // responsive width for larger and smaller screens
                            minWidth: '300px',
                            color: 'white',
                        }),
                    },
                }}
            >
                <Box display="flex" flexDirection="column" gap={2}>
                    <Box>
                        <Typography variant="h6">
                            <FormattedMessage id="globalSettings" />
                        </Typography>
                    </Box>
                    <GlobalContourThicknessModifier />
                    <DoseOpacityModifier />
                    <MonacoExportCheckbox />
                </Box>
            </Menu>
        </>
    );
};

export default GlobalSettings;
